export const NAMESPACE = "FileDetails";

export const SIDEBAR_INSTANCE_ID = "FileDetailsSidebar";
